import { render, staticRenderFns } from "./PlayerLoginForm.vue?vue&type=template&id=167ed3f5&scoped=true&lang=pug&"
import script from "./PlayerLoginForm.vue?vue&type=script&lang=js&"
export * from "./PlayerLoginForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167ed3f5",
  null
  
)

export default component.exports